import { camelCase } from 'lodash';

export class MenuItem {
  id!: string;
  icon!: string;
  label!: string;
  exactPath!: boolean;
  url!: string;
  tooltip?: string;
  order?: number;
  cssClasses?: string;
  counters?: MenuItemCounter[];
  callback?: () => any;

  static getId(id: string) {
    return `${camelCase(id)}MenuButton`;
  }
}

export const workflowMenuItem: MenuItem =
{
  id: MenuItem.getId('workflow'),
  label: 'GLOBAL.GLOBAL.WORKFLOW',
  icon: 'fas fa-home',
  url: '/workflow',
  exactPath: false
};
export const rejectedTiresMenuItem: MenuItem = {
  id: MenuItem.getId('rejectedTires'),
  label: 'WORKFLOW.GLOBAL.REJECTED',
  icon: 'fas fa-trash-alt',
  url: '/workflow/rejected-tires',
  counters: [{ color: 'warning', value: 0 }],
  exactPath: false

};
export const anomalyTiresMenuItem: MenuItem = {
  id: MenuItem.getId('anomalyTires'),
  label: 'WORKFLOW.GLOBAL.DOUBLE_SN',
  icon: 'fas fa-clone',
  url: '/workflow/anomaly-tires',
  counters: [{ color: 'warning', value: 0 }],
  exactPath: false

};
export const damageReportsMenuItem: MenuItem = {
  id: MenuItem.getId('damageReports'),
  label: 'WORKFLOW.GLOBAL.DAMAGE_REPORTS',
  icon: 'fas fa-exclamation-triangle',
  url: '/workflow/damage-reports',
  counters: [{ color: 'warning', value: 0 }],
  exactPath: false
};
export const myBatchesMenuItem: MenuItem = {
  id: MenuItem.getId('myBatches'),
  label: 'WORKFLOW.GLOBAL.MY_BATCHES',
  icon: 'fas fa-database',
  url: '/workflow/my-batches',
  exactPath: false
};
export const myTiresMenuItem: MenuItem = {
  id: MenuItem.getId('myTires'),
  label: 'WORKFLOW.GLOBAL.MY_TIRES',
  icon: 'fas fa-circle-dot',
  url: '/workflow/my-tires',
  exactPath: false

};
export const dashboardMenuItem: MenuItem = {
  id: MenuItem.getId('dashboard'),
  label: 'WORKFLOW.GLOBAL.DASHBOARD',
  icon: 'fas fa-gauge-high',
  url: '/workflow/dashboard',
  exactPath: false
};
export const resetDataMenuItem: MenuItem = {
  id: MenuItem.getId('resetData'),
  label: 'WORKFLOW.GLOBAL.RESET_DATA',
  icon: 'fas fa-rotate-right',
  exactPath: false,
  url: ''
};
export const newContainerMenuItem: MenuItem = {
  id: MenuItem.getId('newContainer'),
  label: 'WORKFLOW.GLOBAL.NEW_CONTAINER',
  icon: 'fas fa-plus-square',
  exactPath: false,
  url: ''
};
export const newPreparationMenuItem: MenuItem = {
  id: MenuItem.getId('newPreparation'),
  label: 'Add new preparation',
  icon: 'fas fa-cart-plus',
  exactPath: false,
  url: ''
};
export const newNotificationMenuItem: MenuItem = {
  id: MenuItem.getId('newNotification'),
  label: 'New Notification',
  icon: 'fas fa-bell',
  exactPath: false,
  url: ''
};

export interface MenuItemCounter {
  color: string;
  value: number;
}

export interface ModeCounter {
  state: number;
  value: number;
}
